module.exports = __webpack_public_path__ + "593a3d53/img/grid-web-icon.d0395d64.svg";